<h4 mat-dialog-title>{{content}}</h4>
<mat-dialog-content>
  <div class="form-group">
    <label for="modification">Modification :</label>
    <textarea name="modification" placeholder="Expliquez nous les éléments à modifier concernant ce laboratoire" class="form-control" [(ngModel)]="modification" id="modification" cols="30" rows="10"></textarea>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">{{cancel}}</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="modification">{{confirm}}</button>
</mat-dialog-actions>
